import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportingDashboardComponent } from './reporting-dashboard/reporting-dashboard.component';

const routes: Routes = [
  { path: '', component: ReportingDashboardComponent, data: { tabIndex: 0 } },
  {
    path: 'tag-engagement',
    component: ReportingDashboardComponent,
    data: { tabIndex: 1 },
  },
  {
    path: 'top-managers-asset-class',
    component: ReportingDashboardComponent,
    data: { tabIndex: 2 },
  },
  {
    path: 'topic-tag-rates',
    component: ReportingDashboardComponent,
    data: { tabIndex: 3 },
  },
  {
    path: 'fund-of-funds',
    component: ReportingDashboardComponent,
    data: { tabIndex: 4 },
  },
  {
    path: 'email-activity',
    component: ReportingDashboardComponent,
    data: { tabIndex: 5 },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportingRoutingModule {}
